import { Decimal } from 'decimal.js';
import { CurrencyCode } from '@insio/shared-types';
import { roundToCurrencyPrecision } from './round-to-currency-precision';
import { isNil } from 'es-toolkit';

/** Converts an amount by an exchange rate and rounds to the target currency precision. */
export function convertAndRound(
  amount: Decimal | null | undefined,
  rate: Decimal,
  currencyCode?: CurrencyCode
): Decimal | null | undefined {
  if (isNil(amount)) return amount;
  return roundToCurrencyPrecision(amount.mul(rate), currencyCode);
}
